export default __webpack_public_path__ + "static/media/customer-2-min.dda80e24.png";